import React, { useState, useEffect } from 'react';
import { LoadingSpinner } from '../../../Components/Molecules/LoadingUI';
import { useDispatch, useSelector } from 'react-redux';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useLocation } from 'react-router-dom';
import { authActions } from '../../../store/auth-slice';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { getConfig } from '../../../utils/config';
import RiArrowRightSLine from '@meronex/icons/ri/RiArrowRightSLine';
import { useHistory } from 'react-router-dom';
import AiOutlineEdit from '@meronex/icons/ai/AiOutlineEdit';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import Modal from '../../../Components/Organisms/Modal';
import BsTrash from '@meronex/icons/bs/BsTrash';
import { cmsClient, winnreAuth } from '../../../utils/axios';
import { Splide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { useData } from './data';
import {
    APIErrorCondition,
    RE_EMAIL,
    RE_NAME,
    RE_Phone,
    RE_Pan
} from '../../../constants';
import { toast } from 'react-toastify';
import MdcTicketPercentOutline from '@meronex/icons/mdc/MdcTicketPercentOutline';
import TiTick from '@meronex/icons/ti/TiTick';
import OfferLayout from '../Components/OfferLayout';
import DeletingContent from '../Components/DeletingContent';
import GrClose from '@meronex/icons/gr/GrClose';
import AiOutlineFileText from '@meronex/icons/ai/AiOutlineFileText';
import BisFilePdf from '@meronex/icons/bi/BisFilePdf';
import FaRegFileImage from '@meronex/icons/fa/FaRegFileImage';
import {
    addSvg,
    deleteSuccessSvg,
    deleteSvg,
    downloadSvg,
    editSvg,
    familySvg,
    trashSvg
} from './svg';

import Select from 'react-select';
import useInput from '../../../Hooks/useInput';
import { usePhoneInput } from '../../../Hooks';
import PhoneInput from 'react-phone-input-2';

const DummyOptions = [
    {
        Name: 'Mother',
        displayName: 'Mother'
    },
    { Name: 'Father', displayName: 'Father' },
    { Name: 'Spouse', displayName: 'Spouse' },
    { Name: 'Child', displayName: 'Child' },
    { Name: 'Brother', displayName: 'Brother' },
    { Name: 'Other', displayName: 'Other' }
];
const DocumentOptions = [
    {
        Name: 'PAN',
        displayName: 'PAN'
    },
    { Name: 'AADHAAR', displayName: 'AADHAAR' }
];

function UserProfile() {
    const {
        isAuthenticated,
        profileCompletionPercentage,
        userName,
        userDetails,
        userId
    } = useSelector((state) => state.auth);
    const { email, birthDate, address } = useSelector(
        (state) => state.auth.userDetails
    );
    const history = useHistory();
    const config = getConfig();
    const location = useLocation();
    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(location.search);
    let accessToken = queryParams.get('token');
    let deleteAccountQuery = queryParams.get('deleteAccount');
    let postLoginUrl = queryParams.get('postLoginUrl');

    const [updateBirthDate, setUpdateBirthDate] = useState(moment());
    const [openModal, setOpenModal] = useState(null);
    const [dobUpdatedMoreThanOnce, setDobUpdatedMoreThanOnce] = useState(false);
    const [updatingDOB, setUpdatingDOB] = useState(false);
    const [document, setDocument] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [file, setFile] = useState(null);
    const [relation, setRelation] = useState({});
    const [deleteMemberId, setDeleteMemberId] = useState(null);
    const [deleteMember, setDeleteMember] = useState(null);
    const [ShowDeleteMessage, setShowDeleteMessage] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
    const [selectedModalDocument, setSelectedModalDocument] = useState(null);

    // console.log("Delete Member" , deleteMember);

    const {
        offers,
        loading,
        deleteClicked,
        setDeleteClicked,
        fetchUserOffers,
        familyMembers,
        setFamilyMembers,
        loadingData,
        setSubmit,
        setUpdate,
        setDeleteTeamMember
    } = useData();

    // Function to handle opening the modal
    const openDocumentModal = (document) => {
        setSelectedModalDocument(document);
        setIsDocumentModalOpen(true);
    };
    const closeDocumentModal = () => {
        setIsDocumentModalOpen(false);
        setSelectedModalDocument(null);
    };

    const handleRelationChange = (val) => {
        setRelation({
            Name: val.value,
            displayName: val.label
        });
    };
    const InitialName = openModal === 'UPDATE' ? selectedMember.name : '';
    const {
        value: name,
        isValid: nameIsValid,
        hasError: nameHasError,
        valueChangeHandler: nameChangedHandler,
        inputBlurHandler: nameBlurHandler,
        reset: resetName
    } = useInput((value) => !RE_NAME.test(value), InitialName);

    const {
        state: {
            isValid: mobileNumberIsValid,
            mobile,
            country,
            mobileHasError,
            isInputFocused
        },
        onChange,
        validator,
        setIsTouched: setMobileIsTouched,
        setMobile,
        getMobileWithoutCountryCode,
        setInputFocused,
        reset: resetPhone
    } = usePhoneInput();

    useEffect(() => {
        if (openModal === 'UPDATE') {
            setMobile(
                `${selectedMember.mobileCountryCode}${selectedMember.mobileNumber}`
            );
        } else {
            setMobile(null);
        }
    }, [openModal, selectedMember]);

    useEffect(() => {
        if (openModal === 'UPDATE') {
            setRelation({
                Name: selectedMember.relationWithParent,
                displayName: selectedMember.relationWithParent
            });
        } else {
            setRelation({});
        }
    }, [openModal, selectedMember]);

    const InitialEmail = openModal === 'UPDATE' ? selectedMember.email : ''; // Choose initial email value

    const {
        value: Email,
        isValid: emailIsValid,
        hasError: emailHasError,
        valueChangeHandler: emailChangedHandler,
        inputBlurHandler: emailBlurHandler,
        reset: resetEmail
    } = useInput((value) => RE_EMAIL.test(value), InitialEmail);
    const {
        value: Pan,
        isValid: PanIsValid,
        hasError: PanHasError,
        valueChangeHandler: PanChangedHandler,
        inputBlurHandler: PanBlurHandler,
        reset: resetPan
    } = useInput((value) => RE_Pan.test(value));

    const {
        value: aadharNumber,
        isValid: aadharNumberIsValid,
        hasError: aadharNumberHasError,
        valueChangeHandler: aadharNumberChangedHandler,
        inputBlurHandler: aadharNumberBlurHandler,
        reset: resetaadharNumber
    } = useInput((value) => value.length == 12);

    const handleDocumentChange = (val) => {
        setDocument({
            Name: val.value,
            displayName: val.label
        });

        resetPan();
        resetaadharNumber();
        setFile(null);
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        // console.log('selectedFile', selectedFile);

        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];

        const maxSize = 3 * 1024 * 1024;

        if (selectedFile) {
            if (!allowedTypes.includes(selectedFile.type)) {
                toast.warning('Only PDF and JPEG files are allowed.');

                return;
            }

            if (selectedFile.size > maxSize) {
                toast.warning('File size should not exceed 3MB.');
                return;
            }

            setFile(selectedFile);
            e.target.value = null;
        }
    };

    const handleSubmit = () => {
        setSubmit(false);
        const docNumber = document.Name === 'AADHAAR' ? aadharNumber : Pan;
        const memberData = {
            name: name,
            mobileNumber: mobile,
            email: Email,
            relationWithParent: relation.Name,
            userRole: 'FAMILY_MEMBER',
            userRoles: ['FAMILY_MEMBER']
        };

        const formDataToSend = new FormData();
        formDataToSend.append('documentFile', file);
        formDataToSend.append('memberData', JSON.stringify(memberData));

        const url = `winnre/parent/team-member/save?documentType=${document.Name}&documentNumber=${docNumber}&appType=CONNECTRE`;
        const headers = {
            'Content-Type': 'multipart/form-data;boundary=',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        };
        winnreAuth
            .post(url, formDataToSend, {
                headers: headers
            })
            .then((res) => {
                if (res?.status == APIErrorCondition) {
                    toast.error(res.message);
                } else {
                    // console.log('Submit res', res);
                    setSubmit(true);
                }
                window?.webengage?.track('AddFamilyMember', {
                    Name: `${name}`,
                    Relationship: `${relation.Name}`,
                    Phone: `${mobile}`,
                    Email: `${Email}`,
                    DocumentType: `${document.Name}`
                });

                resetEmail();
                resetName();
                resetPhone();
                resetPan();
                resetaadharNumber();
                setFile(null);
                setRelation({});
                setDocument({});
                setOpenModal(null);
            });
    };

    useEffect(() => {
        let isValid = false;
        setIsFormValid(isValid);
        if (openModal === 'UPDATE') {
            isValid =
                nameIsValid &&
                mobileNumberIsValid &&
                emailIsValid &&
                relation.Name;
        } else if (openModal === 'ADD') {
            isValid =
                nameIsValid &&
                mobileNumberIsValid &&
                emailIsValid &&
                relation.Name &&
                document.Name &&
                ((document.Name === 'PAN' && PanIsValid) ||
                    (document.Name === 'AADHAAR' && aadharNumberIsValid)) &&
                file;
        }

        setIsFormValid(isValid);
    }, [
        name,
        Email,
        mobile,
        file,
        relation.Name,
        document.Name,
        PanIsValid,
        aadharNumberIsValid
    ]);

    const statusMapping = {
        REGISTERED: 'Registered',
        REJECTED: 'Rejected',
        PENDING_APPROVAL: 'Pending Approval',
        AWAITING_DOCUMENTATION: 'Awaiting Documentation',
        NEW_USER: 'New User'
    };

    const handleUpdate = () => {
        window?.webengage?.track('UpdateMemberClicked');
        setUpdate(false);
        const updatePromises = [];
        const memberDetailsNeedUpdate =
            name?.trim() !== selectedMember.name ||
            mobile?.trim() !== selectedMember.mobileNumber ||
            Email?.trim().toLowerCase() !==
                selectedMember.email?.toLowerCase() ||
            relation.Name?.trim() !== selectedMember.relationWithParent;

        if (memberDetailsNeedUpdate) {
            const updateMemberPromise = winnreAuth({
                method: 'post',
                url: `winnre/parent/teamMember/update?userId=${selectedMember.id}`,
                headers: { 'Content-Type': 'application/json;charset=utf-8' },
                data: JSON.stringify({
                    name,
                    mobileNumber: mobile,
                    email: Email,
                    relationWithParent: relation.Name,
                    userRole: 'FAMILY_MEMBER',
                    userRoles: ['FAMILY_MEMBER']
                })
            }).then((res) => {
                if (res.status === 'FAILED') {
                    console.error(
                        'Failed to update member details:',
                        res.message
                    );
                    toast.error(res?.message);
                } else {
                    // console.log('Member details updated:', res);

                    window?.webengage?.track('UpdateFamilyMember', {
                        Name: `${res?.name}`,
                        Relationship: `${res?.relationWithParent}`,
                        Phone: `${res?.mobileNumber}`,
                        Email: `${res?.email}`
                    });
                    resetEmail();
                    resetName();
                    resetPhone();
                    setRelation({});
                }
            });
            updatePromises.push(updateMemberPromise);
        }

        // Check if document details need updating
        const documentNeedUpdate =
            document.Name &&
            (file ||
                (document.Name === 'AADHAAR' &&
                    aadharNumber !==
                        selectedMember.documents[0]?.documentNumber) ||
                (document.Name === 'PAN' &&
                    Pan !== selectedMember.documents[0]?.documentNumber));
        // Add update document promise if needed
        if (documentNeedUpdate) {
            const docNumber = document.Name === 'AADHAAR' ? aadharNumber : Pan;
            const formDataToSend = new FormData();
            formDataToSend.append('documentFile', file);

            const updateDocumentPromise = winnreAuth
                .post(
                    `winnre/parent/team-member/update-document/${selectedMember.id}/${selectedMember.documents[0].id}?documentType=${document.Name}&documentNumber=${docNumber}`,
                    formDataToSend,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${localStorage.getItem(
                                'accessToken'
                            )}`
                        }
                    }
                )
                .then((res) => {
                    if (res.status === 'FAILED') {
                        console.error(
                            'Failed to update document:',
                            res.message
                        );
                        toast.error(res?.message);
                    } else {
                        // console.log('Document updated:', res);
                        window?.webengage?.track('UpdateDocuments', {
                            DocumentType: `${res?.type}`,
                            Documentnumber: `${res?.documentNumber}`
                        });
                        resetPan();
                        resetaadharNumber();
                        setFile(null);
                        setDocument({});
                    }
                });
            updatePromises.push(updateDocumentPromise);
        }

        // Execute all update promises and set the update state if at least one succeeds
        Promise.allSettled(updatePromises)
            .then((results) => {
                const anySuccessful = results.some(
                    (result) => result.status === 'fulfilled'
                );
                if (anySuccessful) {
                    setUpdate(true);
                    setSelectedMember({});
                    setOpenModal(null);
                }
            })
            .catch((error) => {
                console.error('Unexpected error:', error);
            });
    };

    const handleDelete = () => {
        setDeleteTeamMember(false);
        winnreAuth({
            method: 'POST',
            url: `/winnre/parent/teamMember/delete?teamMemberId=${deleteMemberId}`
        }).then((res) => {
            if (res?.status == APIErrorCondition) {
                toast.error(res.message);
                setOpenModal(null);
                setDeleteMemberId(null);
                setDeleteMember(null);
                return;
            }
            if (res.status === 'SUCCESS') {
                const updatedMembers = familyMembers.filter(
                    (member) => member.id !== deleteMemberId
                );
                window?.webengage?.track('DeleteFamilyMember', {
                    Name: `${deleteMember?.name}`,
                    Relationship: `${deleteMember?.relationWithParent}`,
                    Phone: `${deleteMember?.mobileNumber}`,
                    Email: `${deleteMember?.email}`,
                    DocumentType: `${deleteMember?.documents[0].type}`
                });
                setOpenModal(null);
                setFamilyMembers(updatedMembers);
                setDeleteMemberId(null);
                setDeleteMember(null);
                setDeleteTeamMember(true);
                toast.success('Family member has been deleted successfully');
                return;
            }
        });
    };
    const handleCloseModal = () => {
        setOpenModal(null);
        resetEmail();
        resetName();
        resetPhone();
        resetPan();
        resetaadharNumber();
        setFile(null);
        setRelation({});
        setDocument({});
    };

    const openLoginModal = () => {
        dispatch(authActions.openLoginModal());
    };
    const openPropertyOnboarding = () => {
        dispatch(authActions.openOnboardingModal());
    };

    useEffect(() => {
        if (deleteClicked && isAuthenticated) {
            fetchUserOffers();
        }
    }, [deleteClicked, isAuthenticated]);

    useEffect(() => {
        if (deleteAccountQuery) {
            setDeleteClicked(true);
        }
    }, [deleteAccountQuery]);

    useEffect(() => {
        if (postLoginUrl && !isAuthenticated) {
            openLoginModal();
        }
    }, [postLoginUrl]);

    const handleDateChange = (newValue) => {
        const formattedDate = newValue.format('YYYY-MM-DD');
        dispatch(
            authActions.setUserDetails({
                ...userDetails,
                birthDate: formattedDate
            })
        );
        setUpdateBirthDate(newValue);
    };

    const updateDOB = () => {
        const formattedDate = updateBirthDate.format('YYYY-MM-DD');
        setUpdatingDOB(true);
        winnreAuth({
            method: 'POST',
            url: `/winnre/user/on-board-data`,
            data: JSON.stringify({
                dateOfBirth: formattedDate
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                setUpdatingDOB(false);
                if (res?.status == APIErrorCondition) {
                    toast.error(res.message);
                } else {
                    dispatch(
                        authActions.setUserDetails({
                            fieldName: 'birthDate',
                            value: formattedDate
                        })
                    );
                    setDobUpdatedMoreThanOnce(true);
                    setOpenModal(null);
                }
            })
            .catch((error) => {
                // console.log('Setting modal content to dobUpdateError');
            });
    };

    const deleteUserAccount = () => {
        if (!userId) {
            console.error('User ID not available');
            return;
        }
        winnreAuth({
            method: 'POST',
            url: `/winnre/admin/user/delete?id=${userId}`
        })
            .then((res) => {
                if (res?.status == APIErrorCondition) {
                    toast.error(res.message);
                } else {
                    setOpenModal('DELETE');
                    setTimeout(() => {
                        setOpenModal(null);
                        dispatch(authActions.logout());
                        history.push('/');
                    }, 5000);
                }
            })
            .catch((error) => {
                toast.error(error.message);
            });
    };

    const maxDate = moment().subtract(4, 'years');
    const minDate = moment().subtract(80, 'years');

    useEffect(() => {
        window?.webengage?.track('MyProfileViewed');
        if (
            cmsClient.defaults.baseURL === 'https://prod.loyalie.in' ||
            cmsClient.defaults.baseURL === 'https://uat.loyalie.in'
        ) {
            window.fbq('trackCustom', 'MyProfilePage');
        }
    }, []);

    console.log('Name for update', name);

    // console.log('selected member for update', selectedMember);

    return (
        <>
            {!isAuthenticated && !accessToken && (
                <div className="py-12 flex justify-center">
                    <button
                        onClick={openLoginModal}
                        className="self-start bg-primary text-white py-2 px-6 rounded-lg hover:shadow-xl "
                    >
                        Login to access My Profile
                    </button>
                </div>
            )}
            {isAuthenticated && (
                <div className="w-full lg:pl-5 2xl:pl-7">
                    {deleteClicked ? (
                        <>
                            <div className="w-full border border-gray-300 rounded p-4">
                                <div className="flex flex-col lg:flex-row items-center justify-between">
                                    <div className="flex flex-col lg:flex-row items-center mb-4 lg:mb-0">
                                        <img
                                            src="https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg"
                                            alt="User"
                                            className="object-cover rounded-full w-20 mr-4"
                                        />
                                        <div className="flex flex-col">
                                            <h1 className="font-bold text-lg">
                                                Delete your account?
                                            </h1>
                                            <p className="text-sm text-gray-700 leading-4">
                                                We are sorry to see you go!
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex flex-col w-full lg:w-auto items-center justify-center md:flex-row lg:items-center lg:justify-between mt-4 lg:mt-0 lg:ml-4">
                                        <button
                                            onClick={() =>
                                                setDeleteClicked(false)
                                            }
                                            className="bg-primary text-white px-4 py-2 rounded mb-2 md:mb-0 lg:mr-2 w-full lg:w-auto"
                                        >
                                            Keep my account
                                        </button>
                                        <button
                                            onClick={deleteUserAccount}
                                            className="bg-red-500 text-white px-4 py-2 rounded w-full lg:w-auto"
                                        >
                                            Continue with Deletion
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-14 w-full text-center">
                                <div className="flex flex-col justify-center items-center">
                                    <MdcTicketPercentOutline className="text-[#15509E]  h-7 w-7" />
                                    <h2 className="text-xl font-semibold mb-4">
                                        View exclusive offers curated for you
                                    </h2>
                                </div>
                                {loading && <LoadingSpinner />}
                                {!loading && (
                                    <Splide
                                        options={{
                                            perPage: 3,
                                            perMove: 1,
                                            loop: true,
                                            snap: false,
                                            drag: 'free',
                                            arrow: false,
                                            pagination: true,
                                            breakpoints: {
                                                2560: {
                                                    perPage: 3
                                                },
                                                1024: {
                                                    perPage: 2
                                                },
                                                1000: {
                                                    perPage: 2,
                                                    pagination: false
                                                },
                                                750: {
                                                    perPage: 1,
                                                    pagination: false,
                                                    arrows: false
                                                },
                                                650: {
                                                    perPage: 1,
                                                    pagination: false,
                                                    arrows: false
                                                },
                                                495: {
                                                    perPage: 1,
                                                    gap: '8px',
                                                    pagination: true,
                                                    arrows: true
                                                },
                                                425: {
                                                    perPage: 1,
                                                    gap: '7px',
                                                    pagination: true,
                                                    arrows: true
                                                },
                                                375: {
                                                    perPage: 1,
                                                    gap: '7px',
                                                    pagination: true,
                                                    arrows: true
                                                }
                                            }
                                        }}
                                    >
                                        {offers?.map((deal) => (
                                            <OfferLayout deal={deal} />
                                        ))}
                                    </Splide>
                                )}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className={`w-full`}>
                                <div className="flex justify-center">
                                    <div className="text-center ">
                                        <div className="relative w-28 h-28 mx-auto mb-4">
                                            <CircularProgressbarWithChildren
                                                styles={{
                                                    path: {
                                                        stroke:
                                                            config?.primaryColor ||
                                                            '#4caf50' // Progress stroke color
                                                    },
                                                    trail: {
                                                        stroke: config?.darkMode
                                                            ? '#414141'
                                                            : '#e5e7eb' // Background trail color
                                                    }
                                                }}
                                                strokeWidth={8}
                                                value={
                                                    profileCompletionPercentage
                                                }
                                                className="w-28 h-28"
                                            >
                                                {userName ? (
                                                    <div className="flex items-center justify-center bg-gray-300 rounded-full h-24 w-24 text-3xl lg:text-4xl font-bold text-primary">
                                                        {userName
                                                            .split(' ')
                                                            .map((name) =>
                                                                name[0]?.toUpperCase()
                                                            )
                                                            .join('')}
                                                    </div>
                                                ) : (
                                                    <img
                                                        src="https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg"
                                                        alt="Profile"
                                                        className="rounded-full object-cover h-24 w-24"
                                                    />
                                                )}
                                                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1  text-sm font-semibold text-primary dark:text-white border border-gray-100 rounded-2xl px-2 py-[2px] bg-white ">
                                                    {
                                                        profileCompletionPercentage
                                                    }
                                                    %
                                                </div>
                                            </CircularProgressbarWithChildren>
                                        </div>

                                        <h1 className="capitalize font-Poppins text-xl md:text-xl font-bold">
                                            Welcome, {userName}
                                        </h1>
                                        <h3 className=" font-Poppins pt-1 text-sm md:text-sm">
                                            Enhance security and tailor your
                                            experience by updating your details
                                        </h3>
                                    </div>
                                    {/* {(window.reloy_env.client_config.MY_PROFILE
                                        ?.ALLOW_ONBOARDING &&
                                        profileCompletionPercentage < 100 &&
                                        userDetails?.status == 'REGISTERED') || true && (
                                            <button
                                                onClick={openPropertyOnboarding}
                                                className="bg-info  text-white text-sm md:text-base rounded-[5px] flex justify-center items-center px-2 md:px-4 py-1 h-8 md:h-10 gap-x-1"
                                            >
                                                Complete My Profile
                                            </button>
                                        )} */}
                                </div>
                            </div>
                            {window.reloy_env.client_config.MY_PROFILE
                                ?.ALLOW_ONBOARDING &&
                                profileCompletionPercentage < 100 &&
                                userDetails?.status == 'REGISTERED' && (
                                    <div className="flex justify-center mt-4">
                                        <button
                                            onClick={openPropertyOnboarding}
                                            className="bg-info  text-white text-sm md:text-base rounded-[5px] flex justify-center items-center px-3 md:px-4 py-1 h-8 md:h-10 gap-x-1"
                                        >
                                            Complete My Profile
                                        </button>
                                    </div>
                                )}

                            <div className="grid grid-cols-1 lg:grid-cols-2 lg:pl-5 2xl:pl-7 gap-x-4 lg:gap-x-6 gap-y-7 leading-5 mt-10">
                                {/* BASIC INFO BOX */}
                                <div
                                    className={`border rounded-[5px] relative ${
                                        config?.darkMode
                                            ? 'border-[#414141]'
                                            : 'border-[#e5e7eb]'
                                    }`}
                                >
                                    <div className="p-4 lg:p-5 lg:h-[228px]">
                                        <div className="flex justify-between items-start">
                                            <div>
                                                <h1 className="font-normal lg:text-2xl break-words">
                                                    Basic Information
                                                </h1>
                                                <p className="text-sm text-[#949a98] pb-3 lg:pb-5">
                                                    Access your essential
                                                    details here.
                                                </p>
                                            </div>
                                            <button
                                                onClick={() =>
                                                    setOpenModal('EDIT')
                                                }
                                                className="m-2"
                                            >
                                                <AiOutlineEdit className="inline text-xl" />
                                            </button>
                                        </div>
                                        <div className="flex w-full justify-between">
                                            <div>
                                                <h2 className="text-sm text-[#949a98]">
                                                    Name
                                                </h2>
                                                <h3 className="font-bold lg:text-lg break-words">
                                                    {userName}
                                                </h3>

                                                <h2 className="text-sm text-[#949a98] pt-2 lg:pt-2">
                                                    Date of Birth
                                                </h2>
                                                <h3 className="font-bold lg:text-lg break-words">
                                                    {birthDate ? (
                                                        moment(
                                                            birthDate,
                                                            'YYYY-MM-DD'
                                                        ).format('DD/MM/YYYY')
                                                    ) : (
                                                        <button
                                                            onClick={() =>
                                                                setOpenModal(
                                                                    'EDIT'
                                                                )
                                                            }
                                                            className="font-bold lg:text-lg"
                                                        >
                                                            --/--/--
                                                        </button>
                                                    )}
                                                </h3>
                                                {!birthDate && (
                                                    <p className="text-xs text-gray-500 mt-1">
                                                        Note: This can only be
                                                        updated once.
                                                    </p>
                                                )}
                                            </div>
                                            <div className="justify-end self-end">
                                                <button
                                                    onClick={() =>
                                                        setDeleteClicked(true)
                                                    }
                                                    className=" text-red-500 hover:text-red-700 flex items-center justify-center font-semibold"
                                                >
                                                    <BsTrash className="mr-1" />
                                                    Delete Account?
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* PROFILE COMPLETION BOX */}
                                {/* <div
                                    className={`border rounded-[5px] ${
                                        config?.darkMode
                                            ? 'border-[#414141]'
                                            : 'border-[#e5e7eb]'
                                    }`}
                                >
                                    <div className="p-5 h-[200px] lg:h-[228px] ">
                                        <h1 className="font-normal lg:text-2xl break-words">
                                            Profile Completion
                                        </h1>
                                        <p className="text-sm text-[#949a98] pb-5">
                                            Track your profile's completion
                                            status.
                                        </p>
                                        <div className="flex items-center font-Poppins">
                                            <CircularProgressbarWithChildren
                                                styles={{
                                                    path: {
                                                        stroke: config?.primaryColor
                                                    }
                                                }}
                                                strokeWidth={9}
                                                className="w-24 lg:w-28 lg:h-28 text-primary"
                                                value={
                                                    profileCompletionPercentage
                                                }
                                            >
                                                <div className="font-Poppins text-center font-semibold text-xl xl:text-2xl">
                                                    {
                                                        profileCompletionPercentage
                                                    }
                                                    %
                                                </div>
                                            </CircularProgressbarWithChildren>
                                        </div>
                                    </div>
                                </div> */}
                                {/* EMAIL BOX */}
                                <div
                                    className={`border rounded-[5px] ${
                                        config?.darkMode
                                            ? 'border-[#414141]'
                                            : 'border-[#e5e7eb]'
                                    }`}
                                >
                                    <div className="p-5 h-[140px] lg:h-[168px]">
                                        <h1 className="font-normal lg:text-2xl break-words">
                                            Email Information
                                        </h1>
                                        <p className="text-sm text-[#949a98] pb-5">
                                            View your email details here.
                                        </p>

                                        <h2 className="text-sm text-[#949a98]">
                                            Email
                                        </h2>
                                        <h3 className="font-bold lg:text-lg break-words ">
                                            {email || '-'}
                                        </h3>
                                    </div>
                                </div>
                                {/* ADDRESS BOX */}
                                <div
                                    className={`border rounded-[5px] ${
                                        config?.darkMode
                                            ? 'border-[#414141]'
                                            : 'border-[#e5e7eb]'
                                    }`}
                                >
                                    <div className="p-5 h-[140px] lg:h-[168px]">
                                        <h1 className="font-normal lg:text-2xl break-words">
                                            Address
                                        </h1>
                                        <p className="text-sm text-[#949a98] pb-5">
                                            Review and update your address
                                            details.
                                        </p>

                                        <h3 className="font-bold lg:text-lg break-words">
                                            {address?.line1 || address?.line2
                                                ? `${address?.line1} ${address.line2}`
                                                : '-'}
                                        </h3>
                                    </div>
                                </div>
                                {/* DOC SECTION */}
                                <div
                                    onClick={() => {
                                        history.push('/myprofile/docs');
                                    }}
                                    className={`border rounded-[5px] px-3 py-4 ${
                                        config?.darkMode
                                            ? 'border-[#414141]'
                                            : 'border-[#e5e7eb]'
                                    }`}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                            <img
                                                src="https://cdn.loyalie.in/1698302580432_document_icon"
                                                className=" object-center object-cover rounded-full w-20"
                                            />
                                            <div className="">
                                                <h1 className="font-normal lg:text-2xl break-words">
                                                    Document Center
                                                </h1>
                                                <p className="text-sm text-[#949a98]">
                                                    Manage your documents here
                                                </p>
                                            </div>
                                        </div>

                                        <RiArrowRightSLine className="inline text-primary text-2xl" />
                                    </div>
                                </div>
                                <div
                                    className={`border rounded-[5px] px-8 py-4 lg:col-span-2 flex items-center justify-between ${
                                        config?.darkMode
                                            ? 'border-[#414141]'
                                            : 'border-[#e5e7eb]'
                                    }`}
                                >
                                    <div className="bg-gray-200 rounded-full p-4">
                                        {familySvg}
                                    </div>
                                    <div className="mr-auto px-5">
                                        <h1 className="font-normal text-base md:text-2xl break-words">
                                            Family Members
                                        </h1>
                                        <p className="text-sm text-[#949a98]">
                                            Manage your family members here
                                        </p>
                                    </div>
                                    <button
                                        className="text-primary text-sm md:text-base flex items-center md:gap-1 gap-[2px] cursor-pointer "
                                        onClick={() => setOpenModal('ADD')}
                                    >
                                        {addSvg}

                                        <span className="whitespace-nowrap">
                                            Add New
                                        </span>
                                    </button>
                                </div>

                                {loadingData && (
                                    <div className="flex justify-center">
                                        <LoadingSpinner />
                                    </div>
                                )}
                                {!loadingData &&
                                    familyMembers?.map((member, index) => (
                                        <div
                                            key={index}
                                            className={`border rounded-[5px] px-8 py-4 lg:col-span-2 flex flex-col ${
                                                config?.darkMode
                                                    ? 'border-[#414141]'
                                                    : 'border-[#e5e7eb]'
                                            }`}
                                        >
                                            <div className="flex items-center justify-between">
                                                <div className="mr-2 flex items-center justify-center w-8 h-8 bg-blue-500 text-white rounded-md text-lg font-semibold">
                                                    {member.name
                                                        .charAt(0)
                                                        .toUpperCase()}
                                                </div>
                                                <div className="mr-auto px-2">
                                                    <div className="flex gap-3 items-center">
                                                        <h3 className="text-lg font-semibold">
                                                            {member.name}
                                                        </h3>

                                                        <span className="hidden lg:block px-2 py-1 text-xs text-blue-600 bg-blue-200 rounded-full">
                                                            {
                                                                member.relationWithParent
                                                            }
                                                        </span>
                                                        <span className="hidden lg:block px-2 py-1 text-xs text-green-600 bg-green-200 rounded-full">
                                                            {statusMapping[
                                                                member.status
                                                            ] || member.status}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-4">
                                                    <button
                                                        onClick={() => {
                                                            setSelectedMember(
                                                                member
                                                            );
                                                            setOpenModal(
                                                                'UPDATE'
                                                            );
                                                        }}
                                                    >
                                                        {editSvg}
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setDeleteMemberId(
                                                                member.id
                                                            );
                                                            setDeleteMember(
                                                                member
                                                            );
                                                            setOpenModal(
                                                                'DELETE'
                                                            );
                                                        }}
                                                    >
                                                        {deleteSvg}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="block lg:hidden  mt-2">
                                                <div className="flex items-center gap-3 pl-11">
                                                    <span className="px-2 py-1 text-xs text-blue-600 bg-blue-300 rounded-full">
                                                        {
                                                            member.relationWithParent
                                                        }
                                                    </span>
                                                    <span className="px-2 py-1 text-xs text-green-600 bg-green-200 rounded-full">
                                                        {statusMapping[
                                                            member.status
                                                        ] || member.status}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between pl-11 lg:pl-12 mt-4 gap-6 lg:gap-0">
                                                <div className="flex flex-col items-start gap-1 w-1/3">
                                                    <p className=" text-[#949a98]">
                                                        Phone
                                                    </p>
                                                    <p className="text-bold ">
                                                        {`${member.mobileCountryCode}${member.mobileNumber}`}
                                                    </p>
                                                </div>
                                                <div className="flex flex-col items-start  gap-1 w-1/3">
                                                    <p className=" text-[#949a98]">
                                                        Email
                                                    </p>
                                                    <p className="text-bold ">
                                                        {member.email}
                                                    </p>
                                                </div>
                                                <div className="flex flex-col items-start gap-1 w-1/3">
                                                    <p className=" text-[#949a98]">
                                                        Document
                                                    </p>
                                                    {member.documents?.map(
                                                        (document) => {
                                                            const fileName =
                                                                document.fileKey
                                                                    .split('/')
                                                                    .pop();

                                                            const fileUrl =
                                                                document.link;

                                                            const fileExtension =
                                                                fileName
                                                                    .split('.')
                                                                    .pop()
                                                                    .toLowerCase();

                                                            let icon;
                                                            if (
                                                                fileExtension ===
                                                                'pdf'
                                                            ) {
                                                                icon = (
                                                                    <BisFilePdf className="w-6 h-7 text-red-500" />
                                                                );
                                                            } else if (
                                                                [
                                                                    'png',
                                                                    'jpeg',
                                                                    'jpg'
                                                                ].includes(
                                                                    fileExtension
                                                                )
                                                            ) {
                                                                icon = (
                                                                    <FaRegFileImage className="w-4 h-5 text-red-500" />
                                                                );
                                                            } else {
                                                                icon = (
                                                                    <BisFilePdf className="w-6 h-7 text-red-500" />
                                                                );
                                                            }
                                                            return (
                                                                <div
                                                                    key={
                                                                        document.fileKey
                                                                    }
                                                                    className=""
                                                                >
                                                                    <a
                                                                        onClick={() =>
                                                                            openDocumentModal(
                                                                                document
                                                                            )
                                                                        }
                                                                        href="#"
                                                                        className="flex flex-row items-center gap-1"
                                                                    >
                                                                        {icon}
                                                                        <div className="text-base font-semibold ">
                                                                            {
                                                                                fileName
                                                                            }
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>

                                                <div className="flex flex-col items-start gap-1"></div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </>
                    )}
                </div>
            )}
            <Modal
                visible={openModal != null}
                onClick={() => setOpenModal(null)}
            >
                {openModal == 'EDIT' ? (
                    !updatingDOB ? (
                        <div className="px-7 py-4">
                            <h1 className="font-semibold mb-2">
                                Update your DOB
                            </h1>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label=""
                                    value={updateBirthDate}
                                    onChange={handleDateChange}
                                    maxDate={maxDate}
                                    minDate={minDate}
                                    className="w-full"
                                    format="DD/MM/YYYY"
                                    renderInput={() => null}
                                    sx={{}}
                                    disabled={dobUpdatedMoreThanOnce}
                                />
                            </LocalizationProvider>
                            <p className="text-xs text-gray-500 mt-1">
                                Note: This can only be updated once.
                            </p>
                            <div className="flex justify-end">
                                <button
                                    onClick={updateDOB}
                                    className="bg-primary text-white px-6 py-2 rounded disabled:cursor-not-allowed disabled:bg-gray-200 "
                                    disabled={dobUpdatedMoreThanOnce}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="px-7 py-4 font-semibold flex flex-col justify-center items-center">
                            <div className=" animate-pulse rounded-full bg-green-500 p-2 md:p-4 mb-2">
                                <TiTick className=" text-white h-7 w-7 md:h-8 md:w-8" />
                            </div>
                            <p>Succesfully updating your Date of Birth</p>
                        </div>
                    )
                ) : openModal == 'ADD' || openModal == 'UPDATE' ? (
                    <div className="bg-white rounded-lg px-10 py-4 overflow-y-scroll h-[90vh]">
                        <div className="flex flex-col justify-center">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className=" text-base md:text-xl font-bold">
                                    {openModal === 'ADD'
                                        ? 'Add Family Members'
                                        : 'Update Family Member'}
                                </h2>

                                <GrClose
                                    onClick={handleCloseModal}
                                    className={`self-center h-4 w-4 cursor-pointer`}
                                />
                            </div>

                            <div className="mb-4">
                                <h2>
                                    Your Name
                                    <span className="text-red-400"> *</span>
                                </h2>

                                <input
                                    type="text"
                                    className="w-full mt-2 text-black font-semibold h-12 lg:h-10 xl:h-12 rounded px-2 py-1 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px] placeholder-[#000000B3]"
                                    placeholder="Enter Name"
                                    onChange={nameChangedHandler}
                                    onBlur={nameBlurHandler}
                                    value={name}
                                    autoComplete="off"
                                />
                                {nameHasError && (
                                    <p className="text-left text-red-400 text-sm lg:text-base">
                                        {`Please enter a valid Name`}
                                    </p>
                                )}
                            </div>

                            <div className="pt-1 pb-2">
                                <h2>
                                    Phone Number
                                    <span className="text-red-400"> *</span>
                                </h2>
                                <div className="h-12 lg:h-10 xl:h-12">
                                    <PhoneInput
                                        country={'in'}
                                        containerClass={`mt-1 bg-white text-black rounded-md border-[#BFBFBF] ${
                                            isInputFocused
                                                ? 'border-primary border-[1px]'
                                                : 'border-gray-100'
                                        }`}
                                        countryCodeEditable={false}
                                        containerStyle={{
                                            width: '100%',
                                            height: '100%'
                                        }}
                                        inputStyle={{
                                            width: '100%',
                                            height: '100%',
                                            fontSize: '16px'
                                        }}
                                        buttonStyle={{
                                            backgroundColor: 'white'
                                        }}
                                        isValid={validator}
                                        onChange={onChange}
                                        value={mobile}
                                        enableSearch
                                        onBlur={() => {
                                            setMobileIsTouched(true);
                                            setInputFocused(false);
                                        }}
                                        onFocus={() => setInputFocused(true)}
                                        inputClass="w-full mt-1 text-grey-900 rounded px-2 py-1 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px] placeholder-[#000000B3]"
                                    />
                                </div>
                                {mobileHasError && (
                                    <div>
                                        <p className="text-left text-sm font-semibold text-red-500  ">
                                            Please enter a valid Number
                                        </p>
                                    </div>
                                )}
                            </div>
                            <div className="mb-4">
                                <h2>
                                    Email
                                    <span className="text-red-400"> *</span>
                                </h2>
                                <input
                                    type="text"
                                    className="w-full mt-2 text-black font-semibold h-12 lg:h-10 xl:h-12 rounded px-2 py-1 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px] placeholder-[#000000B3]"
                                    placeholder="Enter Email"
                                    onChange={emailChangedHandler}
                                    onBlur={emailBlurHandler}
                                    value={Email}
                                    autoComplete="off"
                                />
                                {emailHasError && (
                                    <p className="text-left text-sm mt-1 text-red-400">
                                        Please enter a valid email address
                                    </p>
                                )}
                            </div>
                            <div className=" mt-2 md:mt-0 mb-4">
                                <h2>
                                    Relation
                                    <span className="text-red-400"> *</span>
                                </h2>

                                <div className="h-12 lg:h-10 xl:h-12 ">
                                    <Select
                                        placeholder="Relation"
                                        options={DummyOptions?.map((p) => ({
                                            label: p.displayName,
                                            value: p.Name
                                        }))}
                                        onChange={(val) => {
                                            handleRelationChange(val);
                                        }}
                                        value={
                                            relation?.Name
                                                ? {
                                                      value: relation.Name,
                                                      label: relation.displayName
                                                  }
                                                : openModal === 'UPDATE'
                                                ? {
                                                      value: selectedMember.relationWithParent,
                                                      label: selectedMember.relationWithParent
                                                  }
                                                : null
                                        }
                                        styles={{
                                            container: (provided, state) => ({
                                                ...provided,
                                                width: '100%',
                                                color: 'black',
                                                height: '100%'
                                            }),

                                            control: (styles, state) => ({
                                                ...styles,
                                                opacity: '0.95',
                                                height: '100%',
                                                color: 'black',
                                                border: `1px solid #BFBFBF `,
                                                boxShadow: 'none'
                                            }),
                                            placeholder: (styles) => ({
                                                ...styles,
                                                color: '#000000B3',
                                                fontFamily: 'inherit',
                                                fontWeight: 400
                                            })
                                        }}
                                        className={`text-grey-900 placeholder-gray-800 font-semibold bg-white text-base text-left rounded-md mt-2 w-full `}
                                    />
                                </div>
                            </div>
                            <div className=" mt-2 md:mt-0 mb-4">
                                <h2>
                                    Select Documement
                                    <span className="text-red-400"> *</span>
                                </h2>

                                <div className="h-12 lg:h-10 xl:h-12">
                                    <Select
                                        placeholder=""
                                        options={DocumentOptions?.map((p) => ({
                                            label: p.displayName,
                                            value: p.Name
                                        }))}
                                        onChange={(val) => {
                                            handleDocumentChange(val);
                                        }}
                                        value={
                                            document
                                                ? {
                                                      value: document?.Name,
                                                      label: document?.displayName
                                                  }
                                                : null
                                        }
                                        styles={{
                                            container: (provided, state) => ({
                                                ...provided,
                                                width: '100%',
                                                color: 'black',
                                                height: '100%'
                                            }),

                                            control: (styles, state) => ({
                                                ...styles,
                                                opacity: '0.95',
                                                height: '100%',
                                                color: 'black',
                                                border: `1px solid #BFBFBF `,
                                                boxShadow: 'none'
                                            }),
                                            placeholder: (styles) => ({
                                                ...styles,
                                                color: '#000000B3',
                                                fontFamily: 'inherit',
                                                fontWeight: 400
                                            })
                                        }}
                                        className={`text-grey-900 placeholder-gray-800 font-semibold bg-white text-base text-left rounded-md mt-2 w-full  `}
                                    />
                                </div>
                            </div>
                            {document.Name === 'PAN' && (
                                <div className="mb-4">
                                    <h2>
                                        PAN Number
                                        <span className="text-red-400">*</span>
                                    </h2>

                                    <input
                                        className="w-full mt-1 text-black font-semibold h-12 lg:h-10 xl:h-12 rounded px-2 py-1 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px] placeholder-[#000000B3]"
                                        type="text"
                                        placeholder="Pan Number*"
                                        value={Pan}
                                        onChange={(e) => {
                                            PanChangedHandler(e);
                                        }}
                                        onBlur={PanBlurHandler}
                                    />
                                    {PanHasError && (
                                        <p className="text-left text-red-400 text-sm lg:text-base mt-1">
                                            {`Please enter a valid 10-character PAN (e.g., ABCDE1234F).`}
                                        </p>
                                    )}
                                </div>
                            )}

                            {document.Name === 'AADHAAR' && (
                                <div class={`mb-4`}>
                                    <h2>
                                        AADHAAR Number
                                        <span className="text-red-400">*</span>
                                    </h2>
                                    <input
                                        type="text"
                                        className="w-full mt-2 text-black font-semibold h-12 lg:h-10 xl:h-12 rounded px-2 py-1 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px] placeholder-[#000000B3]"
                                        placeholder="Aadhaar Number"
                                        onChange={aadharNumberChangedHandler}
                                        onBlur={aadharNumberBlurHandler}
                                        value={aadharNumber}
                                        autoComplete="off"
                                    />

                                    {(aadharNumberHasError ||
                                        !aadharNumber) && (
                                        <p className="text-left text-sm mt-1 text-red-400">
                                            {`Please enter a valid 12 digit Aadhaar Number`}
                                        </p>
                                    )}
                                </div>
                            )}

                            <div className="mb-4">
                                <div className="flex items-center justify-center w-full">
                                    <label className="flex items-center gap-3 w-full h-20 md:h-16 px-4 bg-gray-100 border-2 border-dashed border-gray-300 rounded-md cursor-pointer">
                                        {downloadSvg}

                                        <div className="flex flex-col">
                                            <span className=" font-medium text-gray-600">
                                                Relationship Document
                                            </span>
                                            <span className=" font-bold text-black">
                                                Choose File
                                            </span>
                                        </div>

                                        <input
                                            type="file"
                                            name="relationship Document"
                                            onChange={handleFileChange}
                                            className="hidden"
                                        />
                                    </label>
                                </div>
                                {file && (
                                    <div className="mt-2 flex items-center gap-1">
                                        <AiOutlineFileText className="text-red-500 text-xl font-bold" />
                                        <div className="text-black font-semibold">
                                            {file.name}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <button
                                onClick={
                                    openModal === 'ADD'
                                        ? handleSubmit
                                        : handleUpdate
                                }
                                disabled={!isFormValid}
                                className={`w-full text-white py-2 px-4 rounded-md ${
                                    isFormValid
                                        ? ' bg-primary'
                                        : 'cursor-not-allowed opacity-70 bg-primary'
                                }`}
                            >
                                {openModal === 'ADD'
                                    ? 'Add Member'
                                    : 'Update Member'}
                            </button>
                        </div>
                    </div>
                ) : openModal == 'DELETE' ? (
                    <>
                        <div className="flex justify-end mr-6 py-3">
                            <GrClose
                                onClick={() => setOpenModal(null)}
                                className={`h-4 w-4 cursor-pointer `}
                            />
                        </div>
                        <div className="flex flex-col justify-center ">
                            <div className="flex justify-center items-center mb-4">
                                {trashSvg}
                            </div>

                            <h2 className="text-xl font-semibold text-center mb-2">
                                Confirm Delete
                            </h2>
                            <p className="text-center text-gray-600 mb-4">
                                Are you sure that you want to delete?
                            </p>

                            <div className="flex items-center justify-center gap-6 mb-4">
                                <button
                                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                                    onClick={() => {
                                        setOpenModal(null);
                                        window?.webengage?.track(
                                            'NoKeepItClicked',
                                            {
                                                Name: `${deleteMember?.name}`,
                                                Relationship: `${deleteMember?.relationWithParent}`,
                                                Phone: `${deleteMember?.mobileNumber}`,
                                                Email: `${deleteMember?.email}`
                                            }
                                        );
                                    }}
                                >
                                    No, Keep it
                                </button>
                                <button
                                    className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
                                    onClick={() => handleDelete()}
                                >
                                    Yes, Delete
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    <DeletingContent />
                )}
            </Modal>
            <Modal
                visible={isDocumentModalOpen}
                onClick={closeDocumentModal}
                className={
                    'w-[60%] md:w-[50%] lg:w-[40%] xl:w-[33%] bg-gray-200 rounded-sm'
                }
            >
                <div className="flex justify-end px-4 mt-4">
                    <GrClose
                        onClick={() => setIsDocumentModalOpen(false)}
                        className={`h-4 w-4 cursor-pointer `}
                    />
                </div>
                <div className="px-4 pt-4 pb-6">
                    {selectedModalDocument && (
                        <>
                            {/* If it's a PDF, show in an iframe */}
                            {selectedModalDocument?.link?.endsWith('.pdf') ? (
                                <iframe
                                    src={selectedModalDocument?.link}
                                    title="PDF Preview"
                                    width="100%"
                                    height="100%"
                                />
                            ) : (
                                /* Otherwise, render image (JPG, PNG, JPEG) */
                                <img
                                    src={selectedModalDocument?.link}
                                    alt={selectedModalDocument?.fileKey}
                                    className=""
                                />
                            )}
                        </>
                    )}
                </div>
            </Modal>
        </>
    );
}

export default UserProfile;
